import { createSlice } from '@reduxjs/toolkit';

const loadingSlice = createSlice({
  name: 'loading',
  initialState: {
    isShow: false,
  },
  reducers: {
    open: state => {
      state.isShow = true;
    },
    close: state => {
      state.isShow = false;
    },
  },
});

export const { open, close } = loadingSlice.actions;
export default loadingSlice.reducer;
